import { Flex, Text, useDateFormat } from '@revolut-internal/ui-kit'
import { FC } from 'react'

type Props = {
  timestamp: string
}

export const DateMessage: FC<Props> = props => {
  const { timestamp } = props

  const dateFormat = useDateFormat()

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      data-testid="dialogue-snapshot-data-message"
    >
      <Text variant="small" color="grey-tone-50" textAlign="center">
        {dateFormat(new Date(timestamp))}
      </Text>
    </Flex>
  )
}
